export const ESC_KEY = 27;
